import { render } from "./BotDeploy.vue?vue&type=template&id=34ea0b53&scoped=true"
import script from "./BotDeploy.vue?vue&type=script&lang=js"
export * from "./BotDeploy.vue?vue&type=script&lang=js"

import "./BotDeploy.vue?vue&type=style&index=0&id=34ea0b53&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ea0b53"]])

export default __exports__